<div
  class="layout-topbar"
>
  <div
    class="layout-topbar-logo-container"
  >
    <button
      class="layout-menu-button layout-topbar-action"
      type="button"
      aria-label="Toggle navigation"
      (click)="toggleSideBar()"
    >
      <i
        class="pi pi-bars"
      >
      </i>
    </button>
    <a
      class="layout-topbar-logo"
      routerLink="/home"
    >
      <img
        class="topbar-logo-full qx-logo-light"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
      <img
        class="topbar-logo-full qx-logo-dark"
        src="assets/logos/pi-signage-full-logo-dark.svg"
        alt="PI Signage"
      >
      <img
        class="topbar-logo-short"
        src="assets/logos/pi-signage-logo.svg"
        alt="PI Signage"
      >
    </a>
  </div>

  <div
    class="qx-topbar-context"
  >
    <span
      class="qx-topbar-label"
    >
      Workspace
    </span>
    <strong>
      {{ organizationName }}
    </strong>
  </div>

  <div
    class="layout-topbar-actions"
  >
    <button
      class="layout-topbar-action"
      type="button"
      title="Toggle color theme"
      aria-label="Toggle color theme"
      (click)="toggleTheme()"
    >
      <i
        [ngClass]="themeIcon"
      >
      </i>
    </button>

    <button
      class="layout-topbar-action qx-profile-action"
      type="button"
      aria-label="Open account menu"
      (click)="userMenu.toggle($event)"
    >
      <p-avatar
        [label]="userInitials"
        shape="circle"
      >
      </p-avatar>
      <span
        class="qx-user-name"
      >
        {{ userName }}
      </span>
    </button>
    <p-menu
      #userMenu
      [model]="userMenuItems"
      [popup]="true"
      appendTo="body"
    >
    </p-menu>
  </div>
</div>
